export default __webpack_public_path__ + "static/media/logo_siege.39079f98.png";